import {
  Component,
  inject,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import {
  TuiInputModule,
  TuiInputPasswordModule,
  TuiTextfieldControllerModule,
} from '@taiga-ui/legacy';
import { TuiCardLarge, TuiHeader } from '@taiga-ui/layout';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { TuiButton, TuiError, TuiSurface } from '@taiga-ui/core';
import { AsyncPipe } from '@angular/common';
import { catchError, map } from 'rxjs';
import { User } from '../models/user';
import { TuiFieldErrorPipe, tuiValidationErrorsProvider } from '@taiga-ui/kit';
import { Router } from '@angular/router';

@Component({
  selector: 'app-connection-page',

  standalone: true,
  imports: [
    ReactiveFormsModule,
    TuiInputPasswordModule,
    TuiInputModule,
    TuiButton,
    TuiHeader,
    TuiCardLarge,
    TuiSurface,
    AsyncPipe,
    TuiError,
    TuiFieldErrorPipe,
    TuiTextfieldControllerModule,
  ],
  templateUrl: './connection-page.component.html',
  styleUrl: './connection-page.component.scss',
  providers: [
    tuiValidationErrorsProvider({
      required: 'Champ obligatoire',
      incorrect: 'Identifiant ou mot de passe incorrect',
    }),
  ],
})
export class ConnectionPageComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly router = inject(Router);

  afficherChampDeConnexion0: WritableSignal<boolean> = signal(false);
  afficherErreurDeConnexion0: WritableSignal<boolean> = signal(false);

  loginForm: FormGroup = this.formBuilder.group({
    username: ['', [Validators.required]],
    password: ['', [Validators.required]],
  });

  ngOnInit(): void {
    var token = localStorage.getItem('token');
    if (token) {
      this.authService
        .verificationConnexion(token)
        .pipe(
          map((user: User) => {
            const redirectUrl = sessionStorage.getItem('redirect_url') || '/';
            sessionStorage.removeItem('redirect_url');
            this.router.navigateByUrl(redirectUrl);

            return user;
          }),
          catchError(
            (error) => (
              this.afficherChampDeConnexion0.set(true),
              localStorage.removeItem('token'),
              (this.authService.token = null),
              (this.authService.user = null),
              error
            ),
          ),
        )
        .subscribe();
    } else {
      this.afficherChampDeConnexion0.set(true);
    }
  }

  onSubmitForm() {
    this.afficherErreurDeConnexion0.set(false);

    if (this.loginForm.valid) {
      this.authService.login(this.loginForm).subscribe({
        next: (user: User) => {
          const redirectUrl = sessionStorage.getItem('redirect_url') || '/';
          sessionStorage.removeItem('redirect_url');
          this.router.navigateByUrl(redirectUrl);

          return user;
        },
        error: (error) => (
          this.afficherChampDeConnexion0.set(true),
          localStorage.removeItem('token'),
          (this.authService.token = null),
          (this.authService.user = null),
          error
        ),
        complete: () => {},
      });
    }
  }
}
